import React from 'react'

const Card = ({text,data}) => {
  return (
    <div className='sing-up-box w-[100%] h-[100px] shadow-metafit-shadow flex flex-col justify-between p-4 bg-white rounded-[10px]'>
        <div className='font-size-update text-sm font-normal text-gray60 '>{text}</div>
        <div className='text-2xl font-semibold '>{data}</div>

    </div>
  )
}

export default Card;

